<template>
    <v-navigation-drawer stateless value="true">
        <search/>
        <v-list v-if="getBookingsNew.length > 0" class="v-list--booking">
            <v-list-item
                :key="item.id"
                active-class="active"
                v-for="item in getBookingsNew"
                @click="editBooking(item.id)"
                :class="`v-list--booking_state  v-list--booking_state--${item.state} ${$route.params.bookingId === item.id ? 'active' : ''}`">
                <v-list-item-title>Бронирование №{{ item.id }}</v-list-item-title>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Search from '../Components/Search'
    import Empty from '../../../../components/Loader/Empty'

    export default {
        name: 'bookingNavigation',
        components: {
            Search,
            Empty
        },
        methods: {
            editBooking (id) {
                this.$router.push({
                    name: 'editBookingForNew',
                    params: { bookingId: id }
                })
            }
        },
        computed: mapGetters([
            'getBookingsNew'
        ])
    }
</script>
